import React from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import GoogleIcon from '../../../components/icon/GoogleIcon'

export default function TaskOptionalSettingCard({
  badge,
  question,
  description,
  checkboxLabel,
  checked = false,
  onChange,
  disabled = false,
  children
}) {
  return (
    <Box className="task-optional-setting">
      {badge && <Box className="task-optional-setting__badge">{badge}</Box>}

      <Typography className="task-optional-setting__question">{question}</Typography>

      {description && (
        <Box className="task-optional-setting__info">
          <span className="task-optional-setting__info-icon-wrap">
            <GoogleIcon name="info_i" size={14} color="#27588D" />
          </span>
          <Typography className="task-optional-setting__info-text">{description}</Typography>
        </Box>
      )}

      <FormControlLabel
        className="task-optional-setting__checkbox"
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            disableRipple
            size="small"
            className="task-optional-setting__checkbox-input"
          />
        }
        label={checkboxLabel}
      />

      {children && <Box className="task-optional-setting__children">{children}</Box>}
    </Box>
  )
}
